export const PRIMARY = 'Inter, Helvetica Neue, system-ui, sans-serif';
export const FALLBACK = 'Helvetica, system-ui, sans-serif';
